import { render, staticRenderFns } from "./DragScroll.vue?vue&type=template&id=7a8cb2e6&scoped=true&"
import script from "./DragScroll.vue?vue&type=script&lang=js&"
export * from "./DragScroll.vue?vue&type=script&lang=js&"
import style0 from "./DragScroll.vue?vue&type=style&index=0&id=7a8cb2e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8cb2e6",
  null
  
)

export default component.exports